import styled from 'styled-components';

export const BaseSection = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #111; 
  color: #F5FFFA;
`;

export const ContentMain = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100vh;
  max-width: 1200px;
  padding: 18px;
`;